import { render, staticRenderFns } from "./FlatDirect.vue?vue&type=template&id=50bb1ac4&scoped=true&"
import script from "./FlatDirect.vue?vue&type=script&lang=js&"
export * from "./FlatDirect.vue?vue&type=script&lang=js&"
import style0 from "./FlatDirect.vue?vue&type=style&index=0&id=50bb1ac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb1ac4",
  null
  
)

export default component.exports